import {atcStates} from '../atc-routes';

export default function AtcCalendarController(
    $scope,
    $state,
    atcApiService,
    atcCalendarService,
    atcFlightsService,
) {
    'ngInject';

    const vm = this;

    Object.assign(vm, {
        $onInit,
        atcCalendarService,
        priceClicked,
        nextWeek,
        prevWeek,
        cancel,
    });

    $scope.request = {};
    $scope.model = {};
    $scope.model.flights = [];
    $scope.model.bestPrice = 0;
    $scope.model.departures = 0;
    $scope.model.roundtrips = true;
    $scope.model.isBusy = true;

    function $onInit() {
        $scope.request = atcCalendarService.getCalendarFlightsRequest();
        getCalendarResult();
    }

    function priceClicked(flight) {
        const req = atcCalendarService.getFindFlightsRequest($scope.request, flight);
        $state.go(atcStates.FLIGHTS_VIEW, {searchConditions: req});
    }

    function prevWeek() {
        atcCalendarService.addDaysToRequestSegments($scope.request.Segments, -7);
        getCalendarResult();
    }

    function nextWeek() {
        atcCalendarService.addDaysToRequestSegments($scope.request.Segments, 7);
        getCalendarResult();
    }

    function cancel() {
        $state.go(atcStates.CHECK_RESULT, {
            pnr: $scope.request.Pnr,
            trip: $scope.request.TripId,
            department: $scope.request.DepartmentId,
            fromTripDetails: $scope.request.FromTripDetails,
        });
    }

    function getCalendarResult() {
        atcApiService.getCalendarPriceMatrix($scope.request)
        .then(function({data}) {
            atcFlightsService.proccessResponse(data);

            atcCalendarService.prepareScopeModel($scope.model, data.Result);
            atcCalendarService.animateResults($scope.model.flights);
        }.bind(this))
        .finally(function() {
            $scope.model.isBusy = false;
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/atc/controllers/atcCalendarController.js